var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-title"},[_c('div',{staticClass:"border"}),_c('div',{staticClass:"title wow fadeIn"},[_vm._v(" "+_vm._s(_vm.titles[0])),_c('br'),(_vm.type == 1)?[_vm._v(" "+_vm._s(_vm.titles[1])+" ")]:[_c('div',{staticClass:"text wow fadeIn"},[_vm._v(_vm._s(_vm.titles[1]))])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }